import {Injectable} from '@angular/core';
import {ParentAPIService} from '../parent.api.service';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {ConfigService} from '../config/config.service';
import {CrystalclearBackUrl} from '../config/crystalclear-back-url';
import {PasswordSecurity} from '../../model/security/password-security';
import {ApiValidation} from "../../model/api/api-validation";
import {map} from "rxjs/operators";
import {MessageService} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class UserService extends ParentAPIService {
  private userLangSource = new Subject<string>();

  constructor(http: HttpClient,
              private messageService: MessageService,
              private translateService: TranslateService,
              configService: ConfigService) {
    super(http);
    this.userLangSource.next(configService.lang);
  }

  sendResetPwdMail(email: string): Observable<ApiValidation<any>> {
    const url = this.getUrl(CrystalclearBackUrl.POST_PASSWORD_MAIL.url);
    return this.http.post<ApiValidation<any>>(url, {email}).pipe(map(
      apiValidation => {
        // if (!apiValidation.success) {
        //   this.infoMessage(apiValidation.message);
        // }
        return apiValidation;
      })
    );
  }

  resetPassword(token: string, new_password: string): Observable<ApiValidation<any>> {
    const url = this.getUrl(CrystalclearBackUrl.POST_PASSWORD_RESET.url);
    return this.http.post<ApiValidation<any>>(url, {token, new_password}).pipe(map(
      apiValidation => {
        if (!apiValidation.success) {
          this.infoMessage(apiValidation.message);
        }
        return apiValidation;
      })
    );
  }

  getPasswordSecurity(): Observable<PasswordSecurity> {
    return this.get<PasswordSecurity>(CrystalclearBackUrl.GET_PASSWORD_SECURITY);
  }

  recoverPassword(username: string, password: string, new_password: string): Observable<ApiValidation<any>> {
    const url = this.getUrl(CrystalclearBackUrl.POST_PASSWORD_RECOVERY.url);
    return this.http.post<ApiValidation<any>>(url, {username, password, new_password}).pipe(map(
      apiValidation => {
        if (!apiValidation.success) {
          this.infoMessage(apiValidation.message);
        }
        return apiValidation;
      })
    );
  }

  protected infoMessage(message: string) {
    if (message)
      this.messageService.add({
        severity: 'info',
        icon: 'fas fa-info-circle',
        // summary: this.getTranslation('common.message.info'),
        detail: this.translateService.instant(message),
        // life: 3000
      });
  }

}
